import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

//--- Styles
import '../styles.scss';

//--- Material Control
import {
  DialogActions,
  Button,
  DialogTitle,
  Dialog,
  Typography,
  IconButton,
  makeStyles,
} from '@material-ui/core';

//--- Material Icon
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import RefreshIcon from '@material-ui/icons/Refresh';
import 'suneditor/dist/css/suneditor.min.css';

import AddressFormItems from '../../../components/FormItem/FormInputAddress/components/components/FormItems';
import AddUpdateMethods from '../components/AddUpdateMethods';
import ConfirmModalView from '../../../components/confirm-modal/confirm-modal';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

export default function AddAddress(props) {
  const {
    isOpen,
    onClose,
    onSuccess,
    setRequestParams,
    provinceSelect,
    langId,
  } = props;
  const [choosePlace, setChoosePlace] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const classes = useStyles();

  const methods = useForm({
    defaultValues: {
      commune: null,
      latitude: '',
      longitude: '',
      street: '',
      generalInfor: '',
      room: '',
      city: '',
      township: '',
      province: null,
      district: null,
    },
  });

  const { handleSubmit, setValue, watch } = methods;

  const [communes, setCommunes] = useState();
  const [districtByProvinceId, setDistrictByProvinceId] = useState();

  const { onSubmit, handleAccept, refresh } = AddUpdateMethods({
    onSuccess,
    setValue,
    watch,
    setCommunes,
    setDistrictByProvinceId,
    choosePlace,
    setRequestParams,
    provinceSelect,
    langId,
    setOpenConfirm,
    openConfirm,
  });

  return (
    <div>
      <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth='lg'>
        <DialogTitle disableTypography className='border-bottom'>
          <Typography variant='h6'>Thêm địa chỉ</Typography>
          <IconButton
            aria-label='close'
            className={classes.closeButton}
            onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
            <AddressFormItems
              provinceSelect={provinceSelect}
              districtByProvinceId={districtByProvinceId}
              communes={communes}
              setChoosePlace={setChoosePlace}
            />

            <DialogActions className='border-top'>
              <Button
                type='button'
                onClick={refresh}
                variant='contained'
                color='primary'
                startIcon={<RefreshIcon />}>
                Refresh
              </Button>
              <Button
                type='button'
                onClick={onClose}
                variant='contained'
                startIcon={<CloseIcon />}>
                Hủy
              </Button>
              <Button
                type='submit'
                color='primary'
                variant='contained'
                startIcon={<SaveIcon />}>
                Lưu
              </Button>
            </DialogActions>
          </form>
        </FormProvider>
      </Dialog>

      <ConfirmModalView
        open={openConfirm}
        content='Thao tác dưới đây cập nhật dữ liệu chọn trên bản đồ vào ô thông tin. Tiếp tục?'
        handleClose={() => setOpenConfirm(false)}
        title='Cập nhật dữ liệu theo bản đồ'
        handleAccept={() => handleAccept()}
      />
    </div>
  );
}
